<template>
  <v-tooltip location="right" :disabled="!rail">
    <template #activator="{ props: tooltipProps }">
      <v-list-item
        v-bind="tooltipProps"
        class="nav-item"
        :class="{ 'nav-item--rail': rail }"
        value="ncrm-notifications"
        @click="openCenter"
      >
        <template #prepend>
          <v-badge
            v-if="unreadCount > 0"
            :content="unreadContent"
            color="error"
            offset-x="4"
            offset-y="4"
            floating
          >
            <v-icon size="22">mdi-bell-outline</v-icon>
          </v-badge>
          <v-icon v-else size="22">mdi-bell-outline</v-icon>
        </template>
        <v-list-item-title class="nav-label">
          {{ $t("navigation.ncrmNotifications") }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <span>{{ $t("navigation.ncrmNotifications") }}</span>
  </v-tooltip>

  <NcrmNotificationCenter
    v-model="centerOpen"
    :enabled="enabled"
    @summary="onSummary"
  />
</template>

<script>
import NcrmNotificationCenter from "./NcrmNotificationCenter.vue";

export default {
  name: "NcrmNotificationNavItem",
  components: { NcrmNotificationCenter },
  props: {
    enabled: { type: Boolean, default: true },
    rail: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false },
  },
  emits: ["close-navigation"],
  data() {
    return {
      centerOpen: false,
      unreadCount: 0,
    };
  },
  computed: {
    unreadContent() {
      return this.unreadCount > 99 ? "99+" : String(this.unreadCount);
    },
  },
  methods: {
    openCenter() {
      this.centerOpen = true;
      if (this.mobile) this.$emit("close-navigation");
    },
    onSummary(summary = {}) {
      this.unreadCount = Math.max(0, Number(summary.unseenCount || 0));
    },
  },
};
</script>

<style scoped>
.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--app-radius-base);
  cursor: pointer;
  color: var(--app-nav-text) !important;
  transition: background 0.15s ease, color 0.15s ease;
}

.nav-item :deep(.v-icon) {
  color: var(--app-nav-text) !important;
}

.nav-item:hover {
  background: var(--app-nav-hover-bg);
  color: var(--app-nav-hover-text) !important;
}

.nav-item:hover :deep(.v-icon) {
  color: var(--app-nav-hover-text) !important;
}

.nav-item--rail {
  justify-content: center;
  padding-inline: 0;
  width: 56px;
  min-width: 56px;
  margin-inline: auto;
}

.nav-item--rail :deep(.v-list-item__content) {
  display: none;
}

.nav-item--rail :deep(.v-list-item__prepend) {
  width: 100%;
  margin-inline-end: 0;
  display: flex;
  justify-content: center;
}

.nav-item--rail :deep(.v-list-item__spacer) {
  width: 0;
}

.nav-label {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
}
</style>
